import React from 'react'

export default (props)=>{
    
    return(
    <>
      <button type="button" onClick={()=> props.RemoveCard(props.pic.id)}>Remove</button>
      <h3>{props.pic.title}</h3>
      <p>{props.pic.date}</p>
      <img src={ props.pic.url } alt="nasa" id="img-date"/>
      
    </>
    )
}
